// src/pages/RpaPage.js
import React from 'react';
import ContactForm from '../components/ContactForm';
import rpapts from '../assets/rpapts.png';
import rparobots from '../assets/rparobots.png';
import employee from '../assets/employee.jpeg';
import rpaImg from '../assets/rpa.jpg';
import transformacaorpa from '../assets/transformacaorpa.png';
import rpahappy from '../assets/rpahappy.png';
import GIFDUV from '../assets/GIFDUV.gif';
import rpaimplementation from '../assets/rpaimplementation.jpg';
import rpatechnologies from '../assets/rpatechnologies.jpg';
import rpa2ways from '../assets/rpa2ways.png';
import rpainvite from '../assets/rpainvite.png';
import rpabanner from '../assets/rpabanner.jpg';
import './Home.css'; // Reaproveitando os mesmos estilos da Home original

// Ícone usado na seção de RPA
const ConsultingIcon = () => <svg height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><polyline points="17 11 19 13 23 9"></polyline></svg>;

const RpaPage = () => {
  const fullCompanyName = "Primo Trade Solutions LTDA";

  const scrollToForm = () => {
    const formSection = document.getElementById('contact-form-section');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // --- OTIMIZAÇÃO SEO: JSON-LD para o Schema de FAQ ---
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Como funciona o orçamento para projetos de RPA?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Para identificar o investimento necessário, nossos especialistas conversarão com você para entender os detalhes dos processos existentes. Você contará com nossa experiência para definir a forma mais efetiva, segura e de melhor custo-benefício para implementar a automação."
        }
      },
      {
        "@type": "Question",
        "name": "Quanto custa para implementar RPA na minha empresa?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "O investimento varia de acordo com a quantidade e complexidade dos processos a serem automatizados. Fatores como o volume de transações, a complexidade das regras de negócio e a integração com sistemas existentes também influenciam na precificação."
        }
      },
      {
        "@type": "Question",
        "name": "Vocês integram RPA com os sistemas já existentes na minha empresa?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Sim. Implementamos soluções de RPA que se integram perfeitamente aos sistemas existentes em sua empresa. Isso inclui ERPs, CRMs, sistemas legados e APIs de terceiros. Nossa equipe tem experiência em criar automações que funcionam harmoniosamente com sua infraestrutura de TI atual."
        }
      },
      {
        "@type": "Question",
        "name": "Quais tecnologias de RPA a PTS DEV utiliza?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Avaliamos os requisitos do seu projeto para escolher a tecnologia mais adequada. A PTS conta com especialistas em várias plataformas líderes, incluindo UiPath, Automation Anywhere, Power Automate (Microsoft) e Python para automação personalizada. Temos as ferramentas e o conhecimento para criar automações eficientes e escaláveis."
        }
      },
      {
        "@type": "Question",
        "name": "Quanto tempo demora para iniciar a implementação de RPA?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Após a assinatura do contrato, iniciamos o desenvolvimento da sua solução de RPA em até 5 dias úteis. Nossa equipe trabalha com metodologias ágeis para garantir eficiência e rapidez na entrega, sempre alinhada às necessidades do seu negócio e focada em resultados rápidos."
        }
      },
      {
        "@type": "Question",
        "name": "Já temos processos automatizados. A PTS pode otimizar e expandir nossa automação?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Sim. Nossa equipe é especialista em otimizar e expandir automações existentes. Realizamos uma avaliação completa dos seus processos atuais, identificamos oportunidades de melhoria e implementamos soluções para aumentar a eficiência. Também podemos migrar automações legadas para tecnologias mais modernas."
        }
      },
      {
        "@type": "Question",
        "name": "Quais são os benefícios de implementar RPA com a PTS?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Redução significativa de custos operacionais, aumento da produtividade, melhoria na qualidade e precisão (zero erros), maior conformidade (compliance), escalabilidade rápida, liberação da equipe para tarefas de valor e suporte contínuo. Nossa abordagem consultiva garante que a automação seja alinhada aos seus objetivos, maximizando o ROI."
        }
      },
      {
        "@type": "Question",
        "name": "Gostaria de conversar sobre a minha aplicação, como faço?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Temos dois caminhos: 1 - Reunião de Levantamento: Podemos fazer uma reunião para definição do escopo e gerar uma cotação. 2 - Chatbot de IA (24/7): Você pode acessar nosso chatbot aqui no site para guiar o levantamento dos requisitos. Com isso, marcamos uma reunião mais direcionada."
        }
      }
    ]
  };

  return (
    <div className="home-page"> 
      {/* --- INÍCIO DA OTIMIZAÇÃO SEO (Padrão React 19) --- */}
      <title>RPA: Automação de Processos e Software Sob Medida | PTS DEV</title>
      <meta name="description" content="Automatize processos repetitivos com RPA e software sob medida. Reduza custos, elimine erros e aumente a produtividade. Peça um diagnóstico gratuito na PTS." />
      <link rel="canonical" href="https://pts.dev.br/rpa-e-automacao" />
      
      {/* Open Graph (para Facebook, LinkedIn, etc.) */}
      <meta property="og:title" content="RPA: Automação de Processos e Software Sob Medida | PTS DEV" />
      <meta property="og:description" content="Automatize processos repetitivos com RPA e software sob medida. Reduza custos, elimine erros e aumente a produtividade. Peça um diagnóstico gratuito na PTS." />
      <meta property="og:url" content="https://pts.dev.br/rpa-e-automacao" />
      <meta property="og:image" content="https://pts.dev.br/static/media/rpapts.png" />
      <meta property="og:type" content="website" />

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="RPA: Automação de Processos e Software Sob Medida | PTS DEV" />
      <meta name="twitter:description" content="Automatize processos repetitivos com RPA e software sob medida. Reduza custos, elimine erros e aumente a produtividade. Peça um diagnóstico gratuito na PTS." />
      <meta name="twitter:image" content="https://pts.dev.br/static/media/rpapts.png" />

      {/* MUDANÇA: Injeção do Schema de FAQ (forma correta) */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      {/* --- FIM DA OTIMIZAÇÃO SEO --- */}

      {/* --- INÍCIO DO HERO BANNER RPA (com imagem de fundo e overlay) --- */}
      <section id="hero-rpa" className="hero-rpa-banner" style={{ backgroundImage: `url(${rpabanner})` }}>
        <div className="hero-rpa-overlay"></div>
        <div className="container hero-rpa-content">
          <h1 className="hero-rpa-title">Automatize Tarefas Repetitivas com RPA</h1>
          <p className="hero-rpa-subtitle">
            Reduza custos, elimine erros e aumente a produtividade.
            Sua equipe livre para focar no que realmente importa.
          </p>
          <button onClick={scrollToForm} className="hero-rpa-cta-button">
            Solicite um Diagnóstico Gratuito
          </button>
        </div>
      </section>
      {/* --- FIM DO HERO BANNER RPA --- */}

      <section id="solutions" className="solutions-section">
        <div className="container">
          <h2 className="section-title">Desenvolvimento de Software e RPA Sob Medida para Digitalizar e Automatizar seu processo</h2>
          <p className="section-subtitle">Construímos as ferramentas que integram sua operação, da gestão interna à entrega final.</p>
          
          {/* --- INÍCIO DA EXPANSÃO RPA (Baseado no PPT) --- */}
          
          {/* SLIDE 1: A Oportunidade Oculta (Encantamento) */}
          <div className="solution-detailed-item rpa-expansion-block">
            <div className="solution-image-container">
              <img src={rpaImg} alt="Conceito de RPA e Automação de Processos para economizar tempo" />
            </div>
            <div className="solution-text-container">
              <ConsultingIcon />
              <h3>A Oportunidade Oculta na Sua Rotina</h3>
              <p className="section-subtitle" style={{fontSize: '1.5rem', fontStyle: 'italic', margin: '20px 0'}}>
                "E se você pudesse parar o tempo gasto em tarefas repetitivas e investir cada segundo em crescimento, inovação e estratégia?"
              </p>
              <p>Esta não é uma pergunta retórica. É a promessa da <strong>Automação de Processos (RPA)</strong>. Na PTS, não apenas implementamos robôs; nós redesenhamos seu fluxo de trabalho para que sua empresa possa focar no que é verdadeiramente humano: a estratégia, a criatividade e o relacionamento com o cliente.</p>
              <button onClick={scrollToForm} className="hero-cta-button" style={{ marginTop: '20px' }}>
                Solicite a sua proposta sem compromisso
              </button>
            </div>
          </div>

          {/* SLIDE 2: A Realidade Invisível (Dor + Agitação) */}
          <div className="solution-detailed-item rpa-expansion-block reverse-layout">
            <div className="solution-text-container">
              <h3>A Realidade Invisível que Freia o Seu Negócio</h3>
              <p><strong>O Custo Silencioso da Repetição</strong></p>
              <p>Sua equipe é brilhante. Mas quanto do talento dela está preso em tarefas que não exigem talento? Esse é o custo invisível que drena sua lucratividade diariamente:</p>
              <ul style={{textAlign: 'left', margin: '15px 0', paddingLeft: '20px'}}>
                <li><strong>Horas Desperdiçadas:</strong> Milhares de horas por ano são consumidas em "copia e cola", preenchimento de planilhas e inserção de dados.</li>
                <li><strong>Erros Humanos:</strong> Um simples erro de digitação pode custar caro em finanças, logística ou compliance. É uma questão de "quando", não de "se".</li>
                <li><strong>Moral Baixo:</strong> Tarefas monótonas matam a criatividade e a motivação. Seus melhores talentos não foram contratados para isso.</li>
                <li><strong>Crescimento Limitado:</strong> Como escalar suas operações se cada novo cliente significa mais trabalho manual e mais contratações para tarefas de baixo valor? Essa não é a fórmula para o futuro. É uma âncora no presente.</li>
              </ul>
              <button onClick={scrollToForm} className="hero-cta-button" style={{ marginTop: '20px' }}>
                Solicite a sua proposta sem compromisso
              </button>
            </div>
            <div className="solution-image-container">
              <img src={employee} alt="Equipe de escritório esgotada com tarefas manuais e repetitivas" /> 
            </div>
          </div>

          {/* SLIDE 3: A Força de Trabalho Digital (A Solução) */}
          <div className="solution-detailed-item rpa-expansion-block">
            <div className="solution-image-container">
              <img src={rparobots} alt="Força de trabalho digital com bots de RPA executando tarefas de software" />
            </div>
            <div className="solution-text-container">
              <h3>E se Existisse uma Força de Trabalho Digital?</h3>
              <p><strong>Apresentando o RPA (Robotic Process Automation)</strong></p>
              <p>Esqueça os robôs de ficção científica. Pense em uma equipe de assistentes virtuais de software—os "bots"—que trabalham incansavelmente dentro dos seus sistemas.</p>
              <p>O que eles fazem? Exatamente o que seus colaboradores fazem em frente ao computador:</p>
              <ul style={{textAlign: 'left', margin: '15px 0', paddingLeft: '20px'}}>
                <li>Login em sistemas (ERP, CRM, portais do governo).</li>
                <li>Leem e enviam e-mails e seus anexos.</li>
                <li>Copiam e colam dados entre diferentes aplicações.</li>
                <li>Preenchem formulários complexos com 100% de precisão.</li>
                <li>Geram relatórios e consolidam informações.</li>
                <li>Seguem regras de negócio ("Se X acontecer, então faça Y").</li>
              </ul>
              <p>Eles são a sua força de trabalho digital, pronta para operar 24/7, sem pausas e sem erros.</p>
              <button onClick={scrollToForm} className="hero-cta-button" style={{ marginTop: '20px' }}>
                Solicite a sua proposta sem compromisso
              </button>
            </div>
          </div>

          {/* SLIDE 4: Benefícios Reais (Prova de Valor + Gatilhos) */}
          <div className="solution-detailed-item rpa-expansion-block reverse-layout">
            <div className="solution-text-container">
              <h3>A Transformação: Os Benefícios Reais do RPA</h3>
              <p><strong>O Futuro da Sua Empresa Começa Aqui:</strong></p>
              <ul style={{textAlign: 'left', margin: '15px 0', paddingLeft: '20px'}}>
                <li><strong>🚀 Produtividade Exponencial:</strong> Nossos bots operam 24/7/365. Processos que levavam horas são concluídos em minutos. Imagine fechar o mês em um dia, não em uma semana.</li>
                <li><strong>💰 ROI Imediato e Inteligente:</strong> Reduza custos operacionais em até 80%. O RPA não é um custo, é um investimento que se paga em meses, liberando capital para inovação.</li>
                <li><strong>🎯 Precisão Absoluta:</strong> Elimine 100% dos erros humanos em tarefas baseadas em regras. Garanta conformidade total (compliance) e dados confiáveis para decisões estratégicas.</li>
                <li><strong>🧠 Liberação do Talento Humano:</strong> Seus funcionários deixam de ser "operadores de dados" para se tornarem "analistas de negócios". Liberte-os para negociar, criar, inovar e atender clientes.</li>
                <li><strong>📈 Escalabilidade Sem Limites:</strong> Dobre seu volume de operações sem dobrar sua equipe. Os bots se adaptam à sua demanda instantaneamente.</li>
                <li><strong>🤝 Experiência do Cliente Aprimorada:</strong> Com processos mais rápidos e sem erros, o tempo de resposta ao cliente diminui drasticamente, elevando a satisfação e a lealdade.</li>
              </ul>
              <button onClick={scrollToForm} className="hero-cta-button" style={{ marginTop: '20px' }}>
                Solicite a sua proposta sem compromisso
              </button>
            </div>
            <div className="solution-image-container">
              <img src={transformacaorpa} alt="Gráfico de benefícios do RPA: produtividade, ROI, precisão e escalabilidade" />
            </div>
          </div>

          {/* SLIDE 5: Onde a Magia Acontece (Exemplos Práticos / Prova Social) */}
          <div className="solution-detailed-item rpa-expansion-block">
            <div className="solution-image-container">
               <img src={rpapts} alt="Exemplos de aplicação de RPA nos setores financeiro, logístico e de RH" />
            </div>
            <div className="solution-text-container">
              <h3>Onde a Magia Acontece? Exemplos por Segmento</h3>
              <p>O RPA não é uma teoria. É uma realidade aplicada. Veja exemplos de aplicações:</p>
              
              <h4>Para o Setor Financeiro e Contábil:</h4>
              <p><strong>Antes:</strong> Clara, a contadora, passava a última semana do mês conciliando extratos bancários manualmente. <strong>Com RPA:</strong> Um bot acessa os portais, baixa os extratos, cruza com o ERP, identifica 99% das transações e entrega para Clara apenas as exceções. Clara agora é uma analista financeira.</p>

              <h4>Para o Comércio Exterior e Logística:</h4>
              <p><strong>Antes:</strong> O time de importação gastava 4 horas por dia inserindo dados de embarques no "Porto Sem Papel" para gerar o DUV. <strong>Com RPA:</strong> O bot lê os dados da fatura, acessa o portal, preenche todos os campos em 10 minutos e avisa a equipe. O time agora foca em otimizar rotas.</p>

              <h4>Para o Recursos Humanos:</h4>
              <p><strong>Antes:</strong> Marcos, do RH, levava 3 dias para o onboarding de um novo funcionário (criar e-mail, solicitar acessos, etc). <strong>Com RPA:</strong> Ao receber o "OK", um bot executa todas essas tarefas em 15 minutos e envia as boas-vindas. Marcos agora se dedica à cultura.</p>
              
              <h4>Para o Setor Comercial e Vendas:</h4>
              <p><strong>Antes:</strong> A equipe de vendas gastava horas atualizando o CRM após cada ligação. <strong>Com RPA:</strong> O vendedor envia um e-mail padronizado para um bot, que extrai as informações e atualiza o CRM. Os vendedores agora passam 100% do tempo vendendo.</p>

              <button onClick={scrollToForm} className="hero-cta-button" style={{ marginTop: '20px' }}>
                Solicite a sua proposta sem compromisso
              </button>
            </div>
          </div>

          {/* SLIDE 6: Quebra de Objeção (Confiança) */}
          <div className="solution-detailed-item rpa-expansion-block reverse-layout">
            <div className="solution-text-container">
              <h3>Mas... os robôs vão roubar nossos empregos?</h3>
              <p><strong>Não. Eles vão devolver o seu verdadeiro trabalho.</strong></p>
              <p>O RPA não substitui pessoas. Ele potencializa pessoas.</p>
              <p><strong>Robôs fazem as TAREFAS. Humanos fazem o TRABALHO.</strong></p>
              <p>Nós automatizamos o que é repetitivo, tedioso e mecânico, para que sua equipe possa focar no que é humano: criatividade, pensamento crítico, empatia, estratégia e relacionamento.</p>
              <p>É a evolução do trabalho. E as empresas que não a abraçarem ficarão para trás.</p>
              <button onClick={scrollToForm} className="hero-cta-button" style={{ marginTop: '20px' }}>
                Solicite a sua proposta sem compromisso
              </button>
            </div>
            <div className="solution-image-container">
              <img src={rpahappy} alt="Profissional focado em estratégia e criatividade após automação de tarefas com RPA" /> 
            </div>
          </div>
          
          {/* SLIDE 7: Exemplo de Bot em Ação (Case Study) */}
          <div className="solution-detailed-item rpa-expansion-block">
            <div className="solution-image-container">
              <img src={GIFDUV} alt="Demonstração de bot RPA automatizando o preenchimento do DUV no portal Porto Sem Papel" />
            </div>
            <div className="solution-text-container">
              <h3>Exemplo de um bot em Ação: Porto Sem Papel</h3>
              <p>Dentro portal do Governo “Porto sem Papel”, o robô simula as atividades de uma pessoa, realizando a inserção de informações necessárias para a criação do DUV e eventualmente a liberação de uma embarcação em um porto marítimo.</p>
              <p>No caso do DUV possui grande aplicação em empresas de importação, podendo ser customizado para diversos sistemas, economizando tempo em atividades repetitivas.</p>
              <p>Outro exemplo é um bot que varre plataformas de recrutamento, lê perfis e currículos, seleciona os que se enquadram nos parâmetros e envia uma tabela pronta para o recrutador, ganhando velocidade na triagem inicial.</p>
              <button onClick={scrollToForm} className="hero-cta-button" style={{ marginTop: '20px' }}>
                Solicite a sua proposta sem compromisso
              </button>
            </div>
          </div>

          {/* SLIDE 8: A Jornada (Processo / Segurança) */}
          <div className="solution-detailed-item rpa-expansion-block reverse-layout">
            <div className="solution-text-container">
              <h3>A Jornada de Implementação com a PTS</h3>
              <p><strong>Simples, Rápida e Segura. Sua transformação em 4 passos:</strong></p>
              <ul style={{textAlign: 'left', margin: '15px 0', paddingLeft: '20px'}}>
                <li><strong>1. Diagnóstico e Mapeamento (O Raio-X):</strong> Nossos especialistas se reúnem com você para entender seus processos e identificar as melhores oportunidades de automação com o maior ROI.</li>
                <li><strong>2. Desenvolvimento Sob Medida (A Arquitetura):</strong> Desenhamos um plano de RPA personalizado. Não usamos soluções de prateleira. Criamos bots que se encaixam perfeitamente na sua operação.</li>
                <li><strong>3. Implementação e Testes (A Construção):</strong> Nossa equipe de desenvolvedores cria e testa as automações em um ambiente seguro, garantindo uma transição suave e sem interrupções.</li>
                <li><strong>4. Treinamento e Suporte Contínuo (A Parceria):</strong> Nós não desaparecemos. Treinamos sua equipe, monitoramos a performance dos bots e oferecemos suporte contínuo para sua automação evoluir com a empresa.</li>
              </ul>
              <button onClick={scrollToForm} className="hero-cta-button" style={{ marginTop: '20px' }}>
                Solicite a sua proposta sem compromisso
              </button>
            </div>
            <div className="solution-image-container">
              <img src={rpaimplementation} alt="Jornada de implementação de RPA em 4 passos: Diagnóstico, Desenvolvimento, Implementação e Suporte" />
            </div>
          </div>

          {/* SLIDE 9: Nossas Tecnologias (Autoridade) */}
          <div className="solution-detailed-item rpa-expansion-block">
            <div className="solution-image-container">
              <img src={rpatechnologies} alt="Tecnologias de RPA: Python e Power Automate para automação de processos" />
            </div>
            <div className="solution-text-container">
              <h3>Nossas Tecnologias - A Caixa de Ferramentas do Futuro</h3>
              <p>Somos agnósticos em tecnologia, focados na sua solução. Dominamos as plataformas líderes de mercado para escolher a ferramenta certa para o seu desafio específico, garantindo a solução mais eficiente, escalável e de melhor custo-benefício.</p>
              <ul style={{textAlign: 'left', margin: '15px 0', paddingLeft: '20px'}}>
                <li><strong>Python:</strong> Para automações customizadas e integrações complexas.</li>
                <li><strong>Power Automate:</strong> Para integração profunda com o ecossistema Microsoft.</li>
              </ul>
              <button onClick={scrollToForm} className="hero-cta-button" style={{ marginTop: '20px' }}>
                Solicite a sua proposta sem compromisso
              </button>
            </div>
          </div>

          {/* SLIDE 10: A Decisão (Urgência / Escassez) */}
          <div className="solution-detailed-item rpa-expansion-block reverse-layout">
            <div className="solution-text-container">
              <h3>A Decisão é Sua. O Futuro é Agora.</h3>
              <p>Você pode continuar no caminho conhecido, onde a concorrência está cada vez mais acirrada e as margens mais apertadas.</p>
              <p><strong>OU</strong></p>
              <p>Você pode pegar a via expressa da eficiência, onde a tecnologia trabalha para você, seus custos diminuem e sua equipe se torna uma força de inovação.</p>
              <p><strong>A janela de oportunidade para se tornar líder em eficiência no seu setor está aberta, mas não para sempre.</strong> Empresas que automatizam hoje terão uma vantagem competitiva impossível de ser alcançada amanhã.</p>
              <button onClick={scrollToForm} className="hero-cta-button" style={{ marginTop: '20px' }}>
                Solicite a sua proposta sem compromisso
              </button>
            </div>
            <div className="solution-image-container">
              <img src={rpa2ways} alt="Decisão entre status quo e inovação com automação de processos RPA" /> 
            </div>
          </div>

          {/* SLIDE 11: O Convite (CTA Principal) */}
          <div className="solution-detailed-item rpa-expansion-block">
            <div className="solution-image-container">
              <img src={rpainvite} alt="Convite para diagnóstico gratuito de potencial de automação RPA pela PTS DEV" />
            </div>
            <div className="solution-text-container">
              <h3>Um Convite Exclusivo para Você</h3>
              <p><strong>Não apenas imagine. Veja.</strong></p>
              <p>Convidamos você para um <strong>Diagnóstico de Potencial de Automação totalmente gratuito</strong> e sem compromisso.</p>
              <p>Nossos especialistas analisarão um de seus processos e mostrarão em um relatório claro:</p>
              <ul style={{textAlign: 'left', margin: '15px 0', paddingLeft: '20px'}}>
                <li>Quantas horas você pode economizar por mês.</li>
                <li>Qual o potencial de redução de custos.</li>
                <li>Como o RPA pode ser aplicado na prática no seu negócio.</li>
              </ul>
              <p>Garanta sua vaga na vanguarda da inovação.</p>
              <button onClick={scrollToForm} className="hero-cta-button" style={{ marginTop: '20px' }}>
                Agende seu Diagnóstico Gratuito Agora
              </button>
            </div>
          </div>
          {/* --- FIM DA EXPANSÃO RPA --- */}
        </div>
      </section>

      {/* SLIDES 12-16: Perguntas Frequentes (FAQ / SEO) */}
      <section id="faq" className="faq-section">
        <div className="container">
          <h2 className="section-title">Perguntas Frequentes sobre RPA</h2>

          <div className="faq-item">
            <h4>Como funciona o orçamento para projetos de RPA?</h4>
            <p>Para identificar o investimento necessário, nossos especialistas conversarão com você para entender os detalhes dos processos existentes. Você contará com nossa experiência para definir a forma mais efetiva, segura e de melhor custo-benefício para implementar a automação.</p>
          </div>
          
          <div className="faq-item">
            <h4>Quanto custa para implementar RPA na minha empresa?</h4>
            <p>O investimento varia de acordo com a quantidade e complexidade dos processos a serem automatizados. Fatores como o volume de transações, a complexidade das regras de negócio e a integração com sistemas existentes também influenciam na precificação.</p>
          </div>

          <div className="faq-item">
            <h4>Vocês integram RPA com os sistemas já existentes na minha empresa?</h4>
            <p>Sim. Implementamos soluções de RPA que se integram perfeitamente aos sistemas existentes em sua empresa. Isso inclui ERPs, CRMs, sistemas legados e APIs de terceiros. Nossa equipe tem experiência em criar automações que funcionam harmoniosamente com sua infraestrutura de TI atual.</p>
          </div>

          <div className="faq-item">
            <h4>Quais tecnologias de RPA a PTS DEV utiliza?</h4>
            <p>Avaliamos os requisitos do seu projeto para escolher a tecnologia mais adequada. A PTS conta com especialistas em várias plataformas líderes, incluindo UiPath, Automation Anywhere, Power Automate (Microsoft) e Python para automação personalizada. Temos as ferramentas e o conhecimento para criar automações eficientes e escaláveis.</p>
          </div>

          <div className="faq-item">
            <h4>Quanto tempo demora para iniciar a implementação de RPA?</h4>
            <p>Após a assinatura do contrato, iniciamos o desenvolvimento da sua solução de RPA em até 5 dias úteis. Nossa equipe trabalha com metodologias ágeis para garantir eficiência e rapidez na entrega, sempre alinhada às necessidades do seu negócio e focada em resultados rápidos.</p>
          </div>

          <div className="faq-item">
            <h4>Já temos processos automatizados. A PTS pode otimizar e expandir nossa automação?</h4>
            <p>Sim. Nossa equipe é especialista em otimizar e expandir automações existentes. Realizamos uma avaliação completa dos seus processos atuais, identificamos oportunidades de melhoria e implementamos soluções para aumentar a eficiência. Também podemos migrar automações legadas para tecnologias mais modernas.</p>
          </div>

          <div className="faq-item">
            <h4>Quais são os benefícios de implementar RPA com a PTS?</h4>
            <p>Redução significativa de custos operacionais, aumento da produtividade, melhoria na qualidade e precisão (zero erros), maior conformidade (compliance), escalabilidade rápida, liberação da equipe para tarefas de valor e suporte contínuo. Nossa abordagem consultiva garante que a automação seja alinhada aos seus objetivos, maximizando o ROI.</p>
          </div>

          <div className="faq-item">
            <h4>Gostaria de conversar sobre a minha aplicação, como faço?</h4>
            <p>Temos dois caminhos: <strong>1 - Reunião de Levantamento:</strong> Podemos fazer uma reunião para definição do escopo e gerar uma cotação. <strong>2 - Chatbot de IA (24/7):</strong> Você pode acessar nosso chatbot aqui no site para guiar o levantamento dos requisitos. Com isso, marcamos uma reunião mais direcionada.</p>
            <div className="button-wrapper">
            </div>
          </div>

        </div>
      </section>

      {/* --- SEÇÕES ORIGINAIS MANTIDAS NO FINAL --- */}
      <section className="scarcity-section">
          <div className="container">
              <h2 className="section-title">Agenda Exclusiva para Novos Projetos de Software</h2>
              <p>Para garantir a máxima qualidade e dedicação total, aceitamos um número limitado de novos parceiros a cada mês. Seja um dos poucos a ter acesso à nossa agenda.</p>
              <button onClick={scrollToForm} className="hero-cta-button" style={{ marginTop: '20px' }}>
                  Poucas vagas por mês. Garanta o seu projeto agora mesmo!
              </button>
          </div>
      </section>

      <section id="contact" className="final-cta-section">
        <div className="container">
          <h2>Pronto para Ter um Software que Realmente Funciona para Você?</h2>
          <p>Chega de sistemas genéricos que não entendem sua necessidade. Empresas de toda a região já confiam na {fullCompanyName} para impulsionar seus resultados. Fale agora com um de nossos especialistas e dê o primeiro passo para a transformação digital definitiva.</p>
          <button onClick={scrollToForm} className="hero-cta-button">
            Solicite uma Proposta Sem Compromisso
          </button>
        </div>
      </section>

      <ContactForm />
    </div> 
  );
};

export default RpaPage;